export const CMS_GRAPHQL_CLIENT_NAME = 'datocms'
